import { CapacityConflictOptionType, CapacityConflictType } from '../types'

/**
 * Which resolution options exist for this conflict, in display order. "time" only
 * exists when the backend suggested later times. Adjusting the order is only offered
 * when something survives - otherwise the adjustment would empty the cart, so
 * deleting it replaces that option.
 *
 * `hasBlockingItems` guards a case that shouldn't happen: an error we can't map to
 * any cart line. Offering "adjust" there would title a step "Remove Blocking
 * Products" over an empty list, so it is left out.
 *
 * `canDeleteOrder` is false when the refused request was the one that would have
 * created the checkout - there is no order to delete yet, so that option is dropped
 * rather than substituted, leaving the later times as the only remedy.
 */
export default function getCapacityConflictOptionTypes(
  type: CapacityConflictType,
  hasTimes: boolean,
  hasBlockingItems: boolean,
  canDeleteOrder: boolean,
): CapacityConflictOptionType[] {
  const isAllBlocked = type === CapacityConflictType.AllProductsBlocked
  const canAdjust = !isAllBlocked && hasBlockingItems

  function getSecondOption() {
    if (canAdjust) {
      return CapacityConflictOptionType.AdjustOrder
    }

    if (canDeleteOrder) {
      return CapacityConflictOptionType.DeleteOrder
    }

    return null
  }

  const secondOption = getSecondOption()
  const options = hasTimes ? [CapacityConflictOptionType.ChangePickupTime] : []

  return secondOption ? [...options, secondOption] : options
}
